import { render, staticRenderFns } from "./DatalistSupport.vue?vue&type=template&id=04b670da"
import script from "./DatalistSupport.vue?vue&type=script&lang=js"
export * from "./DatalistSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports